var _a;
import { EmoteStreamType } from './redux/types';
export var streamTypeToSearchType = (_a = {},
    _a[EmoteStreamType.OFFICIAL] = 'community',
    _a[EmoteStreamType.COMMUNITY] = 'community',
    _a[EmoteStreamType.USER] = 'user',
    _a);
//# sourceMappingURL=constants.js.map